import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: '2rem', textAlign: 'center' }}>
          <h1>Noget gik galt</h1>
          <p style={{ color: '#666', marginTop: '0.5rem' }}>Prøv at genindlæse siden.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: '1rem', padding: '0.5rem 1.5rem', cursor: 'pointer', borderRadius: '4px', border: '1px solid #ccc', background: '#fff' }}
          >
            Genindlæs
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
